import React, { Fragment } from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { KeyboardDatePicker, KeyboardTimePicker } from "@material-ui/pickers";
import QueryBuilder from '@material-ui/icons/QueryBuilder';
import CalendarToday from '@material-ui/icons/CalendarToday';

import PickupOrder from '../../../models/PickupOrder';
import { UserRoleType } from '../../../models/User';

import moment, { Moment } from 'moment';

import style from '../orders/ordersStyle.module.css';
import commonStyles from '../../common/common.module.css';

const styles = (theme: Theme) =>

  createStyles({
    queryBuilder: {
      cursor: 'pointer',
      marginLeft: '14px'
    },
    wrapper: {
      marginTop: 'var(--gap)'
    },
    datePickerInput: {
      '& input': {
        color: 'black',
        fontSize: '14px',
        borderBottom: '1px solid white',
        textTransform: 'uppercase'
       },
       '& button': {
         padding: 0,
       }
    },
    cutOffInput: {
      '& input':{
        color: '#1f1f1f !important', 
        fontSize: '13px',
        fontWeight: 'normal'
      },
    },
    pot1: {
      color: 'var(--primaryblue)',
      fontSize: '12px',
      paddingLeft: '12px',
    },
    pod1: {
      color: '#000',
      fontSize:'22px',
      fontWeight: 600,
      display: 'flex',
      paddingTop: '6px',
    }
  });

interface CommonOrderDateTimeProps {
  classes: any;
  pickupOrder: PickupOrder;
  handleSelectPickUpTime: () => void;
  pickupDate: Moment | string;
  cutoffDate: Moment | string;
  cutoffTime: Moment | string;
  pickupDateChange: ( type: string, date: Moment) => void;
  userRole: UserRoleType;
  changeInputCutOffTime: (event: any) => void;
  type: string;
};

const commonOrderDateTimeDock = (props: CommonOrderDateTimeProps) => {

  const { classes, pickupOrder } = props;
  let newPickupTime: Moment = moment(pickupOrder.pickup_time, 'HH:mm');
  const title: string = props.type === 'po' ? 'Pick Up' : 'Drop Off';


  const pickUpDate: JSX.Element = (!pickupOrder.allowed_ops.update_date || props.type === 'po' || props.userRole === UserRoleType.GHA) ? 
    <Fragment>{ moment(pickupOrder.pickup_date).format('DD MMMM YYYY').toUpperCase() }</Fragment> : 
      <KeyboardDatePicker
        format='DD MMMM YYYY'
        value={ props.pickupDate }
        onChange= { (date: any) => { props.pickupDateChange('pickupDate', date) } } 
        keyboardIcon={ <CalendarToday style={{ fontSize: '19px' }} /> }
        InputProps={{ 
          className: classes.datePickerInput,
          disableUnderline: true
        }}
        autoOk
    />
  
  const pickUpTime: JSX.Element = (props.pickupOrder.allowed_ops.update_date && props.userRole !== UserRoleType.GHA) ? 
    <Fragment>
      <div className={ [style.pod, style.pickupTime].join(' ') }>{  pickupOrder.pickup_time ? moment(newPickupTime).format('HH : mm ') : '-- Select time' }
        <QueryBuilder 
          className={ classes.queryBuilder } 
          onClick={ props.handleSelectPickUpTime } 
        /> 
      </div>     
    </Fragment> :
    <div className={ style.pod }>{pickupOrder.pickup_time ? moment(newPickupTime).format('HH : mm ') : 'Not Assigned'}</div>

  return (
    <Fragment>

      <div className={ style.dtflex }>

        <div className={ [style.dtWrapper, style.dateWidth].join(' ') }>
          <div className={ style.pot }>{ title } Date</div>
          <div className={ style.pod }>{ pickUpDate }</div>
        </div>

        <div className={ [style.dtWrapper, style.dateWidth].join(' ') }>
          <div className={ style.pot }>{ title } Time:</div>
          <Fragment>{ pickUpTime }</Fragment>
        </div>

        <div className={ [style.dtWrapper, style.dateWidth, style.dock].join(' ') }>
          <div className={ style.pot }>Assigned Dock:</div>
          <div className={ style.pod }>{ props.pickupOrder.dock_name || 'Not Assigned' }</div>
        </div>

      </div>

      { (props.type === 'do' && props.userRole !== UserRoleType.GHA) &&
        <Fragment>
          { props.userRole !== UserRoleType.INCOGNITO && 
            <div className={ `${ commonStyles.wrapper } ${ classes.wrapper }` }>
              <h3 className={ `${ commonStyles.header }` }> Cut Off Details</h3>
              <div className={ `${ style.flex } ${ classes.cutOffInput }` }>
                <div className={ [style.infoWrapper2, style.dateWidth].join(' ') }>
                  <div className={ classes.pot1 }>Cut Off Date:</div>
                  <div className={ style.pod1 }>
                    <KeyboardDatePicker
                      format='DD MMMM YYYY'
                      value={ props.cutoffDate }
                      onChange={ (date: any) => { props.pickupDateChange('cutoffDate', date) } }
                      keyboardIcon={ <CalendarToday style={{ fontSize: '19px'}} /> }
                      className={ classes.input }
                      InputProps={{ 
                        className: classes.datePickerInput,
                        disableUnderline: true
                      }}
                      inputVariant="outlined"
                      autoOk
                    />
                  </div>
                </div>

                <div className={ style.infoWrapper2 }>
                  <div className={ classes.pot1 }>Cut Off Time:</div>
                  <div className={ style.pod1 }>
                    <KeyboardTimePicker
                      format='HH:mm'
                      value={ props.cutoffTime }
                      onChange={(date: any)=> {props.pickupDateChange('cutoffTime', date)}}
                      onInput={ props.changeInputCutOffTime }
                      keyboardIcon={ <QueryBuilder/> }
                      className={ classes.input }
                      InputProps={{ 
                        className: classes.datePickerInput,
                        disableUnderline: true,
                      }}
                      inputVariant="outlined"
                    />  
                  </div>
                </div>
                
              </div> 
            </div>
          }

          { props.userRole === UserRoleType.INCOGNITO && 
            <div className={`${ style.wrapper } ${ style.flex } ${ classes.cutOffInput }` }>
              <h3 className={ `${ commonStyles.header }` }> Cut Off Details</h3>
              <div className={ [style.infoWrapper2, style.dateWidth].join(' ') }>
                <div className={ style.pot1 }>Cut Off Date:</div>
                <div className={ [style.pod1,  style.cutOffDateMargin].join(' ')}>{ props.pickupOrder.cutoff_date?  moment(props.pickupOrder.cutoff_date).format('DD MMMM YYYY'): 'Not Assigned' }</div>
              </div>

              <div className={ style.infoWrapper2 }>
                <div className={ style.pot1 }>Cut Off Time:</div>
                <div className={ [style.pod1, style.cutOffTime].join( ' ')  }>{ props.pickupOrder.cutoff_time? props.pickupOrder.cutoff_time.replace(/([\d]{2})([\d]{2})/,'$1:$2'): 'Not Assigned' }</div>
              </div>
            </div>
          }
    
        </Fragment>
      }

      <div className={ style.horizontalLine }></div>

    </Fragment>
  );
}

export default withStyles(styles)(commonOrderDateTimeDock);